import axios from "axios";
import { GROUP_ID } from "../utils/constants";

const { REACT_APP_OTHER_URL, REACT_APP_ALERTS_URL, REACT_APP_SICTM_URL } = process.env;

async function getNotifications(query: any) {
  const { from, until, type } = query;
  const res = await axios.get(
    `/notifications?from=${from}&until=${until}&type=${type}`
  );
  return res.data;
}

async function addNotification(notification: any) {
  const res = await axios.post(`/notifications`, notification);
  return res.data;
}

async function getNotification(notificationId: string) {
  const res = await axios.get(`/notifications/${notificationId}`);
  return res.data;
}

async function deleteNotification(notificationId: string) {
  const res = await axios.delete(`/notifications/${notificationId}`);
  return res.data;
}

async function forceSendNotification(notificationId: string) {
  const res = await axios.post(`/notifications/${notificationId}/send`);
  return res.data;
}

async function addNotificationToUsers(notificationId: string) {
  const res = await axios.post(`/notifications/${notificationId}/user`);
  return res.data;
}

async function getAvisos() {
  const islandId = localStorage.getItem('entity');
  try {
    const res = await axios.get(`${REACT_APP_SICTM_URL}/notices/${islandId}`)
    return res.data;
  } catch (err) { }
}

// TODO revisar si es necesario
async function getAviso(id: number) {
  try {
    const res = await axios.post(`${REACT_APP_OTHER_URL}/assets/avisos/${id}`, {
      groupId: GROUP_ID,
    });
    return res.data;
  } catch (err) { }
}

async function getAvisoSICTMWS(id: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/notices/id/${id}`);
  return res.data;
}

async function getAlerts() {
  const entity = localStorage.getItem("entityId");
  try {
    const res = await axios.get(
      `${REACT_APP_ALERTS_URL}/alerts/${entity ? entity : 4}?dist=WEB`
    );
    return res.data;
  } catch (err) { }
}

export const NotificationsApi = {
  getNotifications,
  addNotification,
  getNotification,
  deleteNotification,
  forceSendNotification,
  addNotificationToUsers,
  getAvisos,
  getAviso,
  getAvisoSICTMWS,
  getAlerts,
};
